import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Typography,
  Row,
} from 'antd';
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';

import ModalConfirmationControls from './ModalConfirmationControls';

const { Text } = Typography;

const ModalConfirmation = ({
  onFinish,
  onFinishText,
  onFinishIcon,
  onCancel,
  onCancelIcon,
  ConfirmAutorize,
  ConfirmCancel,
  ConfirmInactive,
  ConfirmActive,
  Confirm,
  title,
  contentTitle,
  open,
  loading,
  ConfirmRetencion,
  ConfirmSuspension,
  subMessage,
  extraContent,
}) => {
  let confirmationIcon = onFinishIcon;
  let confirmationText = onFinishText;

  if (ConfirmAutorize) {
    confirmationIcon = <CheckCircleOutlined />;
    confirmationText = 'Autorizar';
  } else if (ConfirmCancel) {
    confirmationIcon = <CloseCircleOutlined />;
    confirmationText = 'Cancelar';
  } else if (ConfirmInactive) {
    confirmationIcon = <CloseCircleOutlined />;
    confirmationText = 'Inactivar';
  } else if (ConfirmActive) {
    confirmationIcon = <CheckCircleOutlined />;
    confirmationText = 'Activar';
  } else if (Confirm) {
    confirmationIcon = <CheckCircleOutlined />;
    confirmationText = 'Confirmar';
  } else if (ConfirmRetencion) {
    confirmationIcon = <MinusCircleOutlined />;
    confirmationText = 'Retener';
  } else if (ConfirmSuspension) {
    confirmationIcon = <StopOutlined />;
    confirmationText = 'Suspender';
  }

  return (
    <Modal
      title={(
        <Row justify="space-between">
          <Text>
            {title}
          </Text>
          <ModalConfirmationControls
            onFinish={onFinish}
            onFinishText={confirmationText}
            onFinishIcon={confirmationIcon}
            onCancel={onCancel}
            onCancelIcon={onCancelIcon}
            loading={loading}
          />
        </Row>
    )}
      className="modal-delete"
      open={open}
      footer={null}
      closable={false}
      maskClosable={!loading}
      keyboard={!loading}
      destroyOnClose
    >
      <Text style={{ fontSize: 16 }}>
        ¿Desea
        {' '}
        {contentTitle}
        ?
      </Text>
      {ConfirmAutorize || ConfirmCancel || ConfirmInactive || subMessage ? (
        <Text>
          Esta acción no podrá revertirse
        </Text>
      ) : null}
      {extraContent || null}
    </Modal>
  );
};

ModalConfirmation.propTypes = {
  onFinish: PropTypes.func.isRequired,
  onFinishText: PropTypes.string,
  onFinishIcon: PropTypes.node,
  onCancel: PropTypes.func.isRequired,
  onCancelIcon: PropTypes.node,
  ConfirmAutorize: PropTypes.bool,
  ConfirmCancel: PropTypes.bool,
  ConfirmInactive: PropTypes.bool,
  ConfirmActive: PropTypes.bool,
  Confirm: PropTypes.bool,
  title: PropTypes.string,
  contentTitle: PropTypes.string.isRequired,
  open: PropTypes.bool,
  loading: PropTypes.bool,
  ConfirmRetencion: PropTypes.bool,
  ConfirmSuspension: PropTypes.bool,
  subMessage: PropTypes.bool,
  extraContent: PropTypes.node,
};

ModalConfirmation.defaultProps = {
  onFinishIcon: <ArrowRightOutlined />,
  onCancelIcon: <ArrowLeftOutlined />,
  ConfirmAutorize: false,
  ConfirmCancel: false,
  ConfirmInactive: false,
  ConfirmActive: false,
  Confirm: false,
  title: 'Confirmación',
  onFinishText: 'Continuar',
  open: false,
  loading: false,
  ConfirmRetencion: false,
  ConfirmSuspension: false,
  subMessage: false,
  extraContent: null,
};

export default ModalConfirmation;
